import axios from '@/utils/request/index.js'

const title = async (body) => {
  try {
    const { data } = await axios.post('/title/get', {
      ...body,
    })
    return data.data
  } catch (error) {

    throw error
  }
}


export default {
  title,
}